import styled from 'styled-components'
import theme from 'theme_'

export const WizardLayoutContainer = styled.main`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.grey};
`

export const WizardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${theme.spacing.base};
  background-color: ${theme.colors.white};
  padding: ${theme.spacing.sm} ${theme.spacing.base};
  box-shadow: 10px -10px 10px rgba(0, 0, 0, 0.01);
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.sm} ${theme.spacing.md};
  }
`

export const WizardHeaderLeftBlock = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.base};
`

export const WizardHeaderRightBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  background-color: ${theme.colors.white};
  box-shadow: 10px -10px 10px rgba(0, 0, 0, 0.01);
  @media ${theme.devices.tablet} {
    align-items: center;
  }
`

export const WizardCloseBtn = styled.button`
  background-color: transparent;
  border: 0;
  outline: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`

export const WizardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: ${theme.sizes.maxContentWidth};
  margin: 0 auto;
  padding: ${theme.spacing.base};
  margin-bottom: 100px;
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.base} ${theme.spacing.lg};
  }
`

export const WizardFooter = styled.div`
  position: fixed;
  z-index: ${theme.zIndex.homeAside};
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${theme.colors.white};
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  padding: ${theme.spacing.base};
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.base} ${theme.spacing.lg};
  }
`
